<template>
    <div>
        <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
                <div class="flex pt-6 pb-12 justify-center items-center">
                    <div class="flex flex-col items-center">
                        <h1 class="leading-normal font-semibold text-black text-4xl">
                            Matrix
                        </h1>
                        <h2 class="leading-normal text-grey-darker text-xl">
                            Nutrient Matrix based on our suggested dose
                        </h2>
                    </div>
                </div>
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-2/5 pr-2 flex flex-col justify-between">
                        <div class="">
                            <div class="border-b border-grey-light">

                                <h2 class="leading-6 font-semibold text-black text-2xl">Properties</h2>
                                <div class="md:flex md:items-center mb-5" v-if="dietName != null && dietName != ''">
                                    <div class="md:w-1/2">
                                        <label
                                            class="md:text-right pr-4  block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                            for="dietName"
                                        >
                                            Feed Name
                                        </label>
                                    </div>
                                    <div class="md:w-1/2 flex-shrink">
                                        <input
                                            class="shadow appearance-none w-full text-grey-darkest pr-8 flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded px-3 relative bg-grey-lighter shadow-none cursor-not-allowed"
                                            id="dietName"
                                            name="dietName"
                                            :value="dietName"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="md:flex md:items-center mb-5">
                                    <div class="md:w-1/2">
                                        <label
                                            class="md:text-right pr-4  block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                            for="animalCategory"
                                        >
                                            Animal Category
                                        </label>
                                    </div>
                                    <div class="md:w-1/2 flex-shrink">
                                        <div class="relative">
                                            <select
                                                class="shadow appearance-none w-full text-grey-darkest pr-8 flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded px-3 relative bg-grey-lighter shadow-none cursor-not-allowed"
                                                id="animalCategory"
                                                :value="animal"
                                                disabled
                                                @change="$emit('update:matrixProps', {'type':'animal', 'value': $event.target.value})"
                                            >
                                                <option value="Broiler">Meat Poultry</option>
                                                <option value="Layer">Layers</option>
                                                <option value="Swine">Swine</option>
                                                <option value="Aqua">Aqua</option>
                                            </select>
                                            <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                                                <svg
                                                    class="fill-current h-4 w-4"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20"
                                                >
                                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="md:flex md:items-center mb-5">
                                    <div class="md:w-1/2">
                                        <label
                                            class="md:text-right pr-4  block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                            for="matrixName"
                                        >
                                            Dietary Phytate-P
                                        </label>
                                    </div>
                                    <div class="flex flex-wrap items-stretch md:w-1/2 relative">
                                        <input
                                            type="number"
                                            step="0.001"
                                            :value="roundedPhytate"
                                            @input="handlePhytateInput"
                                            class="flex-shrink flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded rounded-r-none px-3 relative"
                                        >
                                        <div class="flex -mr-px">
                                            <span class="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm shadow-inner">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="md:flex md:items-center mb-5">
                                    <div class="md:w-1/2">
                                        <label
                                            class="md:text-right pr-4  block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                            for="accessibleP"
                                        >
                                            Accessible Phytate-P (80%)
                                        </label>
                                    </div>
                                    <div class="flex flex-wrap items-stretch md:w-1/2 relative">
                                        <input
                                            type="number"
                                            disabled
                                            v-model="roundedAccessiblePhytateP"
                                            class="flex-shrink flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded rounded-r-none px-3 relative input-disabled"
                                        >
                                        <div class="flex -mr-px">
                                            <span class="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm shadow-inner">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="correctedPhytateP !== accessiblePhytateP"
                                    class="md:flex md:items-center mb-5"
                                >
                                    <div class="md:w-1/2">
                                        <label
                                            class="md:text-right pr-4  block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                            for="matrixName"
                                        >
                                            Corrected Accessibility Factor
                                        </label>
                                    </div>
                                    <div class="flex flex-wrap items-stretch md:w-1/2 relative">
                                        <input
                                            type="number"
                                            step="0.001"
                                            :value="roundedAccessibility * 100"
                                            disabled
                                            class="flex-shrink flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded rounded-r-none px-3 relative input-disabled"
                                        >
                                        <div class="flex -mr-px">
                                            <span class="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm shadow-inner">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="correctedPhytateP !== accessiblePhytateP"
                                    class="md:flex md:items-center mb-5"
                                >
                                    <div class="md:w-1/2">
                                        <label
                                            class="md:text-right pr-4  block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                            for="accessibleP"
                                        >
                                            Corrected Phytate-P
                                        </label>
                                    </div>
                                    <div class="flex flex-wrap items-stretch md:w-1/2 relative">
                                        <input
                                            type="number"
                                            disabled
                                            v-model="roundedCorrectedPhytateP"
                                            class="flex-shrink flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded rounded-r-none px-3 relative input-disabled"
                                        >
                                        <div class="flex -mr-px">
                                            <span class="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm shadow-inner">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="md:flex md:items-center mb-5">
                                    <div class="md:w-1/2">
                                        <label
                                            class="md:text-right pr-4  block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                            for="productForm"
                                        >
                                            Product Form
                                        </label>
                                    </div>
                                    <div class="md:w-1/2 flex-shrink">
                                        <div class="relative">
                                            <select
                                                class="shadow appearance-none w-full bg-white text-grey-darkest pr-8 flex-grow leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded px-3 relative cursor-pointer"
                                                id="productForm"
                                                :value="product"
                                                @change="$emit('update:matrixProps',{'type':'product', 'value': $event.target.value})"
                                            >
                                                <option value="HiPhos 10,000 GT">HiPhos 10,000 GT</option>
                                                <option value="HiPhos 20,000 GT">HiPhos 20,000 GT</option>
                                                <option value="HiPhos 20,000 L">HiPhos 20,000 L</option>
                                                <option value="HiPhos 50,000 M">HiPhos 50,000 M</option>
                                                <option value="HiPhos 65,000 L">HiPhos 65,000 L</option>
                                            </select>
                                            <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                                                <svg
                                                    class="fill-current h-4 w-4"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20"
                                                >
                                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="md:flex md:items-center mb-5">
                                    <div class="md:w-1/2">
                                        <label
                                            class="md:text-right pr-4 leading-tight  block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                            for="accessibleP"
                                        >
                                            <span v-show="suggestedDose == dose">Suggested </span>Dose
                                            <span
                                                class="w-6 h-full ml-1 flex-no-shrink inline-block align-middle"
                                                v-if="suggestedDose == dose"
                                                v-tooltip="{
                                                    content: 'This dose prediction is the biological optimum and not necessarily the economic optimum',
                                                    show: showDoseTooltip
                                                }"
                                                @click="showDoseTooltip = !showDoseTooltip"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    v-show="suggestedDose == dose"
                                                    class="icon-help stroke-current fill-none font-semibold text-primary inline-block"
                                                >
                                                    <path
                                                        class="primary"
                                                        d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
                                                    />
                                                    <path
                                                        class="secondary fill-primary"
                                                        d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
                                                    /></svg>
                                            </span><br>
                                            <a
                                                v-show="suggestedDose != dose"
                                                class="font-thin text-sm"
                                                @click="resetToSuggestedDose"
                                            >reset to suggested</a>
                                        </label>
                                    </div>
                                    <div class="flex flex-wrap flex-col items-stretch md:w-1/2 relative">
                                        <div class="flex flex-wrap items-stretch flex-1 relative">
                                            <input
                                                type="number"
                                                :min="doseFytMin"
                                                :max="doseFytMax"
                                                v-model="doseInFYT"
                                                @input="doseFYTUpdated"
                                                @blur="handleDoseOnBlur('FYT')"
                                                class="flex-shrink flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded rounded-r-none px-3 relative"
                                            >
                                            <div class="flex -mr-px">
                                                <span class="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm shadow-inner">FYT</span>
                                            </div>
                                        </div>
                                        <div class="flex flex-wrap items-stretch flex-1 mt-2 relative">
                                            <input
                                                type="number"
                                                :min="dosePpmMin"
                                                :max="dosePpmMax"
                                                v-model="doseInPPM"
                                                @input="dosePPMUpdated"
                                                @blur="handleDoseOnBlur('PPM')"
                                                class="flex-shrink flex-grow flex-auto leading-normal text-grey-darkest w-px flex-1 shadow-inner border h-10 border-grey-light rounded rounded-r-none px-3 relative "
                                            >
                                            <div class="flex -mr-px">
                                                <span class="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm shadow-inner">ppm</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="animal != 'Aqua'">
                                <p class="text-sm text-grey-darker">* Matrix values are typically not fully additive and therefore need to be adjusted when multiple enzymes are used in the same feed to avoid overestimation of the contribution from the combination.</p>
                            </div>
                            <div class="w-full pt-5">
                                <div class="bg-blue-white px-4 py-5 sm:p-6">
                                    <div class="w-full flex flex-col">
                                        <div class=" md:flex md:items-center" :class="animal != 'Aqua' && animal != 'Swine' ? 'mb-5' : ''">
                                            <div class="md:w-1/3">
                                                <label
                                                    class="md:text-right pr-4 block text-grey-darker text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0"
                                                    for="phospatePrice"
                                                >
                                                    Phosphate Type
                                                </label>
                                            </div>
                                            <div class="md:w-2/3 flex-shrink">
                                                <div class="relative">
                                                    <select
                                                        class="shadow appearance-none w-full text-xs sm:text-sm md:text-base text-grey-darkest pr-8 flex-grow leading-normal text-grey-darkest w-px flex-1 shadow-inner h-10 rounded px-3 relative cursor-pointer"
                                                        :class="selectedPhosphateType == '' ? (calculateROIerror == true ? 'bg-red-lightest border-2 border-red-dark' : 'bg-primary-lightest border-2 border-primary-dark') : 'border border-grey-light bg-white'"
                                                        id="productForm"
                                                        v-model="selectedPhosphateType"
                                                        ref="phosphateTypeInput"
                                                    >
                                                        <option disabled hidden value="">Select phosphate</option>
                                                        <option v-for="phosphateType in phosphateTypes" :key="phosphateType" :value="phosphateType" :selected="selectedPhosphateType == phosphateType">{{phosphateType}} <span>({{phosphateTypesObject != null ? phosphateTypesObject[phosphateType].fullName : ''}})</span></option>
                                                    </select>
                                                    <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                                                        <svg
                                                            class="fill-current h-4 w-4"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 20 20"
                                                        >
                                                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="md:flex md:items-center w-full" v-if="animal != 'Aqua' && animal != 'Swine'">
                                            <div class="md:w-1/3">
                                                <label
                                                    class="md:text-right pr-4 text-grey-dark text-xs sm:text-sm md:text-base font-medium mb-1 md:mb-0 flex justify-start md:justify-end"
                                                    for="digestibility"
                                                >
                                                    Digestibility
                                                    <v-popover
                                                        popoverBaseClass="bg-white shadow"
                                                        :open="showDigestibilityTooltip"
                                                        :close="showDigestibilityTooltip"
                                                    >
                                                        <span
                                                            class="w-6 h-full ml-1 flex-no-shrink inline-block align-middle"
                                                            @click="showDigestibilityTooltip = !showDigestibilityTooltip"
                                                            @mouseenter="showDigestibilityTooltip = true"
                                                            @mouseleave="showDigestibilityTooltip = false"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 24 24"
                                                                class="icon-help stroke-current fill-none font-semibold text-primary inline-block"
                                                            >
                                                                <path
                                                                    class="primary"
                                                                    d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
                                                                />
                                                                <path
                                                                    class="secondary fill-primary"
                                                                    d="M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
                                                                /></svg>
                                                        </span>
                                                        <template slot="popover">
                                                            <div class="max-h-10">
                                                                <img src="/images/dig-ph-calculation.png" alt="" class="h-12">
                                                            </div>
                                                        </template>
                                                    </v-popover>
                                                </label>
                                            </div>
                                            <div class="md:w-2/3 flex-shrink">
                                                <div class="flex flex-wrap items-stretch flex-1 relative">
                                                    <div class="flex -mr-px">
                                                        <span class="flex items-center leading-normal bg-grey-lightest rounded rounded-r-none border border-r-0 border-grey-lighter px-3 whitespace-no-wrap text-grey text-sm shadow-inner">%</span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        id="digestibility"
                                                        step="0.1"
                                                        v-model="digestibility"
                                                        class="flex-shrink flex-grow flex-auto leading-normal text-grey-darker w-px flex-1 shadow-inner border h-10 border-grey-lighter rounded rounded-l-none px-3 relative"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-center p-4">
                                <button
                                    :style="{ backgroundColor: '#0b5aaa', color: 'white', padding: '1rem 1.5rem', border: 'none' }"
                                    class="btn rounded text-sm md:text-base"
                                    @click="handleCalculateROIClick"
                                >Calculate ROI</button>
                            </div>
                        </div>
                        <div class="flex flex-col items-center text-center mt-8">
                            <div class="text-2xl text-primary-dark font-semibold mb-4">DSM’s Business Drivers for Sustainability</div>
                            <div class="flex justify-center">
                                <img src="/images/business-driver.png" alt="making efficient use of natural resources" class="mx-4 h-48">
                                <img src="/images/business-driver2.png" alt="reducing emissions in livestock" class="mx-4 h-48">
                            </div>
                        </div>
                    </div>
                    <div class="w-full md:w-3/5 pl-2">
                        <div class="flex justify-end mb-2" v-if="animal != 'Aqua'">

                            <a
                                @click="showHelpModal = true"
                                class="pr-8 inline-flex"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    class="icon-light fill-current h-6 w-6"
                                >
                                    <path
                                        class="primary"
                                        d="M5 8a7 7 0 1 1 10.62 6l-.64 3.2a1 1 0 0 1-.98.8h-4a1 1 0 0 1-.98-.8L8.38 14A7 7 0 0 1 5 8zm12 0a5 5 0 0 0-5-5 1 1 0 0 0 0 2 3 3 0 0 1 3 3 1 1 0 0 0 2 0z"
                                    />
                                    <path
                                        class="secondary"
                                        d="M15 21a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2 1 1 0 0 1 0-2h6a1 1 0 0 1 0 2z"
                                    />
                                </svg>
                                <span class="pl-1">How is this calculated?</span></a>
                        </div>
                        <div class="box" :class="animal == 'Aqua' ? 'mt-8' : ''">
                        <table class="table w-full">
                            <thead>
                                <th class="text-center uppercase text-xs">Nutrient</th>
                                <th class="text-center uppercase text-xs">
                                    <toggle-switch
                                        :options="myOptions"
                                        v-model="selectedUnit"
                                    >
                                    </toggle-switch>
                                </th>
                                <th class="text-center uppercase text-xs">Contribution</th>
                                <th class="text-center uppercase text-xs">Matrix</th>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="row in selectedUnit == '%' ? matrixInPctg : rows"
                                    :key="row.id"
                                >
                                    <td class="text-center">{{row.name}}</td>
                                    <td class="text-center">{{row.unit}}</td>
                                    <td class="text-center">{{row.contribution}}</td>
                                    <td class="text-center">{{row.value.toLocaleString()}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-blue-lightest-alt overflow-hidden shadow rounded-lg mt-6" ref="container" id="roiComponent">
            <div class="px-4 py-5 sm:p-6 sm:pb-12 flex flex-col justify-center items-center">
                <div class="flex pt-6 pb-12 justify-center items-center">
                    <div class="flex flex-col items-start">
                        <h1 class="leading-normal font-semibold text-blue-darker text-4xl">
                            What's your ROI?
                        </h1>
                        <p class="leading-normal text-grey-darker text-sm">
                            *based upon replacement of inorganic phosphate
                        </p>
                    </div>
                </div>
                <div class="w-full md:w-2/3 lg:1/2">
                    <ROI 
                        :selected-product="product"
                        :selected-animal="animal"
                        :ppmDose="doseInPPM"
                        :avPhContribution="rows[0].contribution"
                        :availability.sync="availability"
                        :totalPhosphorus.sync="totalPhosphorus"
                        :phosphatePrice.sync="phosphatePrice"
                        :hiphosPrice.sync="hiphosPrice"
                        :selectedPhosphateType.sync="selectedPhosphateType"
                        :phosphateTypes="phosphateTypes"
                        :phosphateTypesObject="phosphateTypesObject"
                        @phosphateReplacementUpdated="phosphateReplacement = $event"
                        @avPUpdated="avP = $event"
                    />
                </div>
            </div>
        </div>
        <div class="bg-green-lightest overflow-hidden shadow rounded-lg mt-6">
            <div class="px-4 py-5 sm:p-6">
                <div class="flex pt-6 pb-8 justify-center items-center">
                    <div class="flex flex-col items-center">
                        <h1 class="leading-normal font-semibold text-green-darker text-4xl">
                            Sustainability
                        </h1>
                    </div>
                </div>
                <Sustainability 
                    :selected-product="product"
                    :selected-animal="animal"
                    :ppm-dose="doseInPPM"
                    :av-ph-contribution="rows[0].contribution"
                    :phosphate-replacement="phosphateReplacement"
                    :totalPhosphorus="totalPhosphorus"
                    :avP="avP"
                />
            </div>
        </div>
        <custom-modal
            :showModal="exportModalActive"
            title="Export Matrix"
            @update:showModal="data => $emit('update:exportModalActive', data)"
            :submitBtn="{text:'Download', type:'info'}"
            @submit="handleExportModalSubmit"
        >
            <div slot="body">
                <h2>Select the format of the exportable file.</h2>
                <div class="py-4 flex justify-around items-center">
                    <div
                        class="rounded-lg shadow-md hover:shadow-lg max-w-2xs "
                        :class="selectedFileFormat == 'csv' ? 'shadow-lg border-4 border-primary' : ' '"
                        @click="handleFormatSelect('csv')"
                    >
                        <img
                            class="w-full"
                            src="/images/csv.png"
                            alt="csv"
                        >
                    </div>
                    <div
                        class="rounded-lg shadow-md hover:shadow-lg max-w-2xs"
                        :class="selectedFileFormat == 'xlsx' ? 'shadow-lg border-4 border-primary' : ' '"
                        @click="handleFormatSelect('xlsx')"
                    >
                        <img
                            class="w-full"
                            src="/images/xlsx.png"
                            alt="xlsx"
                        >
                    </div>
                    <div
                        class="rounded-lg shadow-md hover:shadow-lg max-w-2xs"
                        :class="selectedFileFormat == 'pdf' ? 'shadow-lg border-4 border-primary' : ' '"
                        @click="handleFormatSelect('pdf')"
                    >
                        <img
                            class="w-full"
                            src="/images/pdf.png"
                            alt="pdf"
                        >
                    </div>
                </div>
                <div class="py-4 flex justify-left align-center items-baseline">
                    <div class="pr-2">Export with properties?</div>
                    <div class="pl-2">
                        <toggle-button
                            class="tglFontSize"
                            :value="exportWithProperties"
                            :color="{checked: '#38c172', unchecked: '#dfe0df'}"
                            :sync="true"
                            @change="(payload) => $emit('update:exportWithProperties', payload.value)"
                            :disabled="withPropertiesSwitchDisabled"
                        />
                    </div>
                </div>
            </div>
        </custom-modal>
        <custom-modal
            :showModal="showSaveMatrixModal"
            title="Save Calculation"
            @update:showModal="data => $emit('update:showSaveMatrixModal',data)"
            :submitBtn="{text:'Save', type:'success'}"
            @submit="handleSaveMatrix(false)"
        >
            <div slot="body">
                <label
                    class="block text-grey-darker  mb-2"
                    for="matrixName"
                >
                    Set an optional name identifier for your calculation. Alternatively, leave blank for an auto-generated name to be used.
                </label>
                <input
                    v-model="saveMatrixName"
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                    id="matrixName"
                    type="text"
                    placeholder="My Calculation"
                >
            </div>
            <div slot="footer-additional-button">
                <button
                    v-show="matrixId != 0"
                    class="btn btn-blank"
                    @click="handleSaveMatrix(true)"
                >Save As New</button>
            </div>
        </custom-modal>
        <custom-modal
            :showModal="showHelpModal"
            title="How is this calculated?"
            @update:showModal="newValue => showHelpModal = newValue"
            :showFooter="true"
            :cardStyleClass="'w-full'"
            :modalStyleClass="'px-4 lg:px-32'"
            :cancelBtn="{ text: 'Close', type: 'blank' }"
            :showSubmitBtn="false"
        >
            <div
                slot="body"
                class="flex flex-col items-center xl:px-32"
            >
                <label
                    class="block text-grey-darker mb-4 text-lg sm:text-xl md:text-2xl"
                    for="matrixName"
                >
                    The following are a few possible phytase/phytate scenarios in practical diets.
                </label>
                <div class="bg-blue-lightest border-l-4 border-blue-light text-blue-darkest px-4 py-3 mb-4 flex items-center">
                    <div class="h-8 w-8 mr-4 flex-no-shrink">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="icon-information w-full h-full stroke-current fill-none font-semibold text-primary inline-block"
                        >
                            <path
                                class="primary"
                                d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
                            />
                            <path
                                class="secondary"
                                d="M11 12a1 1 0 0 1 0-2h2a1 1 0 0 1 .96 1.27L12.33 17H13a1 1 0 0 1 0 2h-2a1 1 0 0 1-.96-1.27L11.67 12H11zm2-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                            /></svg>
                    </div>
                    <div>For more information refer to the <a
                            class="shadow-underline font-semibold"
                            href="/research-paper/pfn"
                            target="_blank"
                        >Phytate Free Nutrition paper</a>
                        <span v-if="animal == 'Broiler'"> & <a
                                class="shadow-underline font-semibold"
                                href="/research-paper/paa-bro"
                                target="_blank"
                            >Phytase AA meta Broilers paper</a></span>
                        <span v-if="animal == 'Swine'"> & <a
                                class="shadow-underline font-semibold"
                                href="/research-paper/paa-pigs"
                                target="_blank"
                            >Phytase AA meta Pigs paper</a></span>
                    </div>
                </div>
                <img
                    src="/images/fig1.png"
                    alt="fig1"
                >
                <img
                    src="/images/fig2.png"
                    alt="fig2"
                >
                <img
                    src="/images/fig3.png"
                    alt="fig3"
                >
            </div>
        </custom-modal>
    </div>
</template>

<script>
import ToggleButton from "vue-js-toggle-button/src/Button";
import ROI from "./ROI";
import Sustainability from "./Sustainability.vue";
import {
    PRODUCT_FORM_MAP as productFormMap,
    DOSE_FYT_MIN,
    DOSE_FYT_MAX,
    PHOSPHATE_DEFAULTS as phospateDefaults,
    PRODUCT_DEFAULT_PRICES as productDefaultPrices
} from "../utilities/application";
import smoothHeight from 'vue-smooth-height';

export default {
    mixins:[smoothHeight],

    components: {
        ToggleButton,
        ROI,
        Sustainability,
    },

    props: [
        "rows",
        "phytate",
        "accessibility",
        "animal",
        "product",
        "dose",
        "suggestedDose",
        "accessiblePhytateP",
        "correctedPhytateP",
        "exportModalActive",
        "exportWithProperties",
        "showSaveMatrixModal",
        "matrixId",
        "matrixName",
        "dietName",
        "currentMatrix"
    ],

    data() {
        return {
            selectedUnit: "%",
            myOptions: {
                layout: {
                    color: "black",
                    backgroundColor: "white",
                    selectedColor: "white",
                    selectedBackgroundColor: "blue",
                    borderColor: "black",
                    fontFamily: "Arial",
                    fontWeight: "normal",
                    fontWeightSelected: "bold",
                    squareCorners: false,
                    noBorder: false
                },
                size: {
                    fontSize: 12,
                    height: 25,
                    padding: 3,
                    width: 80
                },
                items: {
                    delay: 0.4,
                    preSelected: "%",
                    disabled: false,
                    labels: [
                        {
                            name: "g/Kg",
                            color: "white",
                            backgroundColor: "#0f7cea"
                        },
                        {
                            name: "%",
                            color: "white",
                            backgroundColor: "#0f7cea"
                        }
                    ]
                }
            },
            selectedFileFormat: "",
            saveMatrixName: this.matrixName,
            doseInFYT: this.dose,
            doseInPPM: _.round(
                (this.dose / productFormMap[this.product]) * 1000,
                2
            ),
            showHelpModal: false,
            doseLimit: {
                Broiler: 3000,
                Swine: 3000,
                Layer: 1800,
                Aqua: 3000
            },
            d3000: 1000,
            showDoseTooltip: false,
            showDigestibilityTooltip: false,
            showAvailabilityTooltip: false,
            phosphateReplacement: 0,
            avP: 0,
            selectedPhosphateType: this.currentMatrix && this.currentMatrix.phosphateType ? this.currentMatrix.phosphateType : "",
            availability: this.currentMatrix && this.currentMatrix.availability ? this.currentMatrix.availability : _.get(phospateDefaults, [this.animal,this.selectedPhosphateType,'available'],0),
            phosphatePrice: this.currentMatrix && this.currentMatrix.phosphatePrice ? this.currentMatrix.phosphatePrice : _.get(phospateDefaults, [this.animal,this.selectedPhosphateType,'price'],0),
            totalPhosphorus: this.currentMatrix && this.currentMatrix.totalPhosphorus ? this.currentMatrix.totalPhosphorus : _.get(phospateDefaults, [this.animal,this.selectedPhosphateType,'total'],0),
            digestibility: this.currentMatrix && this.currentMatrix.digestibility ? this.currentMatrix.digestibility : _.get(phospateDefaults, [this.animal,this.selectedPhosphateType,'digFactor'],0),
            hiphosPrice: this.currentMatrix && this.currentMatrix.hiphosPrice ? this.currentMatrix.hiphosPrice : _.get(productDefaultPrices, this.product,0),
            calculateROIerror: false,
        };
    },

    mounted: function() {
        this.$smoothElement({
            el: this.$refs.container,
        })
    },

    computed: {
        roundedPhytate: function() {
            return _.round(this.phytate, 3);
        },
        roundedAccessiblePhytateP: function() {
            return _.round(this.accessiblePhytateP, 3);
        },
        roundedCorrectedPhytateP: function() {
            return _.round(this.correctedPhytateP, 3);
        },
        matrixInPctg: function() {
            return this.rows.map(row => {
                return !_.includes(this.nonSwappableNutrients, row.name)
                    ? {
                          ...row,
                          unit: "%",
                          contribution: _.round(row.contribution / 10, 4),
                          value: _.round(row.value / 10, 4)
                      }
                    : row;
            });
        },
        withPropertiesSwitchDisabled: function() {
            return this.selectedFileFormat == "csv" ? true : false;
        },
        nonSwappableNutrients: function() {
            return this.rows
                .filter(row => row.unit != "g/Kg")
                .map(row => row.name);
        },
        roundedAccessibility: function() {
            return _.round(this.accessibility, 2);
        },
        doseFytMin: function() {
            return DOSE_FYT_MIN[this.animal];
        },
        doseFytMax: function() {
            return DOSE_FYT_MAX[this.animal];
        },
        dosePpmMin: function() {
            return _.round(
                (this.doseFytMin / productFormMap[this.product]) * 1000,
                2
            );
        },
        dosePpmMax: function() {
            return _.round(
                (this.doseFytMax / productFormMap[this.product]) * 1000,
                2
            );
        },
        phosphateTypes: function() {
            return _.keys(_.get(phospateDefaults, this.animal,{}));
        },
        phosphateTypesObject: function() {
            return _.get(phospateDefaults, this.animal, null);
        },

    },

    watch: {
        product(newValue, oldValue) {
            this.doseInPPM = _.round(
                (this.doseInFYT / productFormMap[this.product]) * 1000,
                2
            );
        },
        dose(newValue, oldValue) {
            this.doseInFYT = this.dose;
            this.doseInPPM = _.round(
                (this.dose / productFormMap[this.product]) * 1000,
                2
            );
        },
        selectedPhosphateType(newValue) {
            this.digestibility = _.get(phospateDefaults, [this.animal,this.selectedPhosphateType,'digFactor'],0);
            this.phosphatePrice = _.get(phospateDefaults, [this.animal, newValue, 'price'],0);
            this.totalPhosphorus = _.get(phospateDefaults, [this.animal, newValue,'total'],0);
            this.availability = _.get(phospateDefaults, [this.animal, newValue,'available'],0);
            this.$emit('update:matrixProps', { type: 'phosphateType', value: newValue });
        },
        phosphatePrice(newValue) {
            this.$emit('update:matrixProps', { type: 'phosphatePrice', value: newValue });
        },

        totalPhosphorus(newValue) {
            this.$emit('update:matrixProps', { type: 'totalPhosphorus', value: newValue });
        },
        
        digestibility(newValue) {
            this.$emit("update:matrixProps", {
                type: "digestibility",
                value: newValue
            });
        }
    },

    methods: {
        handleExportModalSubmit() {
            this.$emit("update:exportModalActive", false);
            EventHub.$emit("exportMatrix", {
                matrixInPctg: this.matrixInPctg,
                selectedUnit: this.selectedUnit
            });
        },

        handleFormatSelect(fileFormat) {
            this.selectedFileFormat = fileFormat;
            if (this.selectedFileFormat == "csv")
                this.$emit("update:exportWithProperties", false);
            EventHub.$emit("fileFormatUpdated", this.selectedFileFormat);
        },

        handleSaveMatrix(isNew) {
            this.$emit("update:showSaveMatrixModal", false);
            EventHub.$emit("saveMatrix", {
                matrixName: this.saveMatrixName,
                isNew: isNew
            });
        },

        dosePPMUpdated() {
            this.doseInFYT =
                (this.doseInPPM * productFormMap[this.product]) / 1000;
            if (this.doseInFYT > this.doseLimit[this.animal]) {
                this.undoDoseUpdate();
            }
            if (
                this.doseInPPM === "" ||
                this.doseInPPM <= 0 ||
                isNaN(this.doseInPPM)
            )
                return;
            this.$emit("update:matrixProps", {
                type: "dose",
                doseInFYT: this.doseInFYT,
                doseInPPM: this.doseInPPM
            });
        },

        doseFYTUpdated(event) {
            if (this.doseInFYT > this.doseLimit[this.animal]) {
                this.undoDoseUpdate();
            }
            this.doseInPPM = _.round(
                (this.doseInFYT / productFormMap[this.product]) * 1000,
                2
            );
            if (
                this.doseInFYT === "" ||
                this.doseInFYT <= 0 ||
                isNaN(this.doseInFYT)
            )
                return;
            this.$emit("update:matrixProps", {
                type: "dose",
                doseInFYT: this.doseInFYT,
                doseInPPM: this.doseInPPM
            });
        },

        undoDoseUpdate() {
            this.doseInFYT = this.dose;
            this.doseInPPM = _.round(
                (this.doseInFYT / productFormMap[this.product]) * 1000,
                2
            );
        },

        handlePhytateInput(e) {
            if (_.isNaN(e.target.value) || e.target.value == 0) {
                return;
            }

            this.$emit("update:matrixProps", {
                type: "phytate",
                value: e.target.value
            });
        },

        resetToSuggestedDose() {
            this.doseInFYT = this.suggestedDose;
            this.doseFYTUpdated();
        },

        handleDoseOnBlur(type) {
            if (type == "FYT") {
                this.doseInFYT = this.dose;
                this.doseFYTUpdated();
            } else if (type == "PPM") {
                this.doseInPPM = this.calculateDoseInPPM(this.dose);
                this.dosePPMUpdated();
            }
        },

        calculateDoseInPPM(localDoseInFYT) {
            return _.round(
                (localDoseInFYT / productFormMap[this.product]) * 1000,
                2
            );
        },

        scrollToId(elId) {
            this.$scrollTo(`#${elId}`, 1000, { easing: "ease-in-out" });
        },
        
        handleCalculateROIClick() {
            if(this.selectedPhosphateType && this.selectedPhosphateType !== "") {
                this.scrollToId('roiComponent');
            } else {
                this.calculateROIerror = true;
            }
        },
    }
};
</script>
<style>
.box-margin-bottom {
    margin-bottom: 30px !important;
}

#matrix-props .button.is-static {
    border: none !important;
}

.text-center {
    text-align: center !important;
}
</style>
